'use client';

import { Icon } from '@/src/shared/ui/icons/Icon';
import { cn } from '@/src/shared/lib/utils';

interface ChatFloatingButtonProps {
  onClick: () => void;
  unreadCount?: number;
  className?: string;
}

/**
 * Chat Floating Button - Button to open the mini chat widget
 *
 * Shows a chat icon with optional unread badge
 */
export const ChatFloatingButton = ({
  onClick,
  unreadCount = 0,
  className,
}: ChatFloatingButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'fixed bottom-5 right-5 z-50',
        'w-16 h-16 rounded-full',
        'bg-accent-secondary hover:bg-accent-secondary/90',
        'shadow-[0_4px_20px_rgba(0,0,0,0.2)]',
        'flex items-center justify-center',
        'transition-all duration-200 ease-in-out',
        'hover:scale-105 active:scale-95',
        className
      )}
      aria-label="Open chat"
    >
      {/* Chat icon */}
      <Icon name="variant32" size="xl" color="inverse" />

      {/* Unread badge */}
      {unreadCount > 0 && (
        <div
          className={cn(
            'absolute -top-1 -right-1',
            'min-w-6 h-6 px-1.5',
            'bg-feedback-attention rounded-full',
            'flex items-center justify-center',
            'animate-pulse'
          )}
        >
          <span className="text-text-inverse text-sm font-extrabold font-['Roboto']">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        </div>
      )}
    </button>
  );
};
